/**
 * Mensagem do liga/desliga do usuario — funcao pura (FORM-21).
 *
 * Desativar um vendedor zera o `responsavel_padrao` dos formularios que
 * apontavam para ele. Sem dizer isso na tela, a captacao do site troca de dono
 * em silencio: os leads novos passam a nascer sem responsavel e ninguem e
 * avisado, porque o follow-up so cobra o proprio responsavel.
 */
import { plural } from "../../../utils/dinheiro";

export function mensagemDeStatusDoUsuario(ativo, formulariosAfetados = 0) {
  if (ativo) return "Usuário ativado.";
  const quantos = Number(formulariosAfetados) || 0;
  if (quantos <= 0) return "Usuário desativado.";
  return (
    `Usuário desativado. ${plural(quantos, "formulário do site ficou", "formulários do site ficaram")}`
    + " sem responsável padrão: escolha outro vendedor no Editor do formulário."
  );
}

export default mensagemDeStatusDoUsuario;
